import { render, staticRenderFns } from "./MyFrom.vue?vue&type=template&id=0b053f11&scoped=true&"
import script from "./MyFrom.vue?vue&type=script&lang=js&"
export * from "./MyFrom.vue?vue&type=script&lang=js&"
import style0 from "./MyFrom.vue?vue&type=style&index=0&id=0b053f11&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b053f11",
  null
  
)

export default component.exports